import { FC, useMemo, useContext, PropsWithChildren } from 'react';
import useTrials from '@/hooks/data/useTrials';
import TrialsContext from '@/contexts/data/TrialsContext';
import { QueryTrialsResponse } from '@/api/dtos';
import IsLoading from '@/components/layouts/IsLoading';


export interface ITrialsProviderProps {
    initial?: QueryTrialsResponse;
}

export const TrialsProvider: FC<PropsWithChildren<ITrialsProviderProps>> = ({ initial, children }) => {
    const trials = useTrials({}, { revalidateOnFocus: false, fallbackData: initial});

    return (

        <TrialsContext.Provider value={trials}>
            <IsLoading name="trials" loading={trials.loading} validating={trials.validating}/>
            {children}
        </TrialsContext.Provider>
    );
}

export default TrialsProvider;
